import classNames from "classnames";
import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { useTemplate } from "PFApp/hooks";
import { Inline, Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { useActivityNameAndId } from "PFCore/helpers/activities";
import { useTranslation } from "react-i18next";

import { useTranslatedActivityType } from "../../../hooks/use_translated_activity_type";
import css from "./header.module.scss";
import { ActivityActions } from "./parts/activity_actions";
import { AssignmentActions } from "./parts/assignment_actions";
import { CoreInformationRow } from "./parts/core_information_row";
import { WorkflowBreadcrumbs } from "./parts/workflow_breadcrumbs";

type HeaderProps = {
  className?: string;
};

export const Header = ({ className }: HeaderProps) => {
  const { t } = useTranslation("activities");
  const activity = useCurrentActivity();

  const getActivityNameId = useActivityNameAndId();

  const templateName = useTranslatedActivityType(activity);
  const template = useTemplate(activity.template_id);

  if (!activity) {
    return null;
  }

  const nameAndId = getActivityNameId(activity);

  return (
    <Stack
      gap="spacingSm"
      className={classNames(css.header, className)}
      role="region"
      aria-label={t("show.activitySummary")}
      qaId="ActivityPage.summary"
    >
      {activity.shortlist_assignment && template?.shortlist_invites && (
        <AssignmentActions shortlistItem={activity.shortlist_assignment} template={template} />
      )}
      <WorkflowBreadcrumbs />
      <Inline spread>
        <Typography variant="h1" className={css.roleTitle}>
          {`${templateName}: ${nameAndId.name}`}
        </Typography>
        <ActivityActions />
      </Inline>
      <CoreInformationRow />
    </Stack>
  );
};
